import { useEffect } from "react";
import { syncPushToken } from "../lib/push";

let synced = false;

/**
 * Один раз за сессию регистрирует токен, если разрешение уже выдано.
 */
export const usePushSync = () => {
  useEffect(() => {
    if (synced) {
      return;
    }

    synced = true;
    syncPushToken().catch((error) => {
      synced = false;
      console.error("[push] token sync failed", error);
    });
  }, []);
};
